<script>

import { onMount, tick } from 'svelte';
import Loader from 'components/webdesq/loader.svelte';
import QrCode from 'components/webdesq/qrcode.svelte';

const icons = {
  authenticator: '<linearGradient id="a" x1="0" x2="1" y1="0" y2="0" gradientTransform="scale(768.18446) rotate(25 -1 0)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff" stop-opacity=".2"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient></defs><path fill="#999" d="M592 384a208 208 0 11-65-151l133-115A383 383 0 000 384a384 384 0 00768 0zm0 0"/><path fill="gray" fill-rule="evenodd" d="M768 384a384 384 0 11-768 0 384 384 0 01768 0zm0 0"/><path fill="#999" d="M608 384a224 224 0 11-69-162l121-104A383 383 0 000 384a384 384 0 00768 0zm0 0"/><path fill="#b3b3b3" fill-rule="evenodd" d="M416 80a32 32 0 11-64 0 32 32 0 0164 0zm0 0M416 688a32 32 0 11-64 0 32 32 0 0164 0zm0 0M112 384a32 32 0 11-64 0 32 32 0 0164 0zm0 0M192 576a32 32 0 11-46 46 32 32 0 0146-46zm0 0M622 576a32 32 0 11-46 46 32 32 0 0146-46zm0 0M192 146a32 32 0 11-46 46 32 32 0 0146-46zm0 0"/><path fill="gray" fill-rule="evenodd" d="M576 384a192 192 0 11-384 0 192 192 0 01384 0zm0 0"/><path fill="gray" fill-rule="evenodd" d="M608 384a224 224 0 11-448 0 224 224 0 01448 0zm0 0"/><path fill="#fff" fill-opacity=".2" d="M608 392v-4a224 224 0 01-448 0v4a224 224 0 00448 0zm0 0"/><path fill="#4d4d4d" d="M605 416h-98c3-10 5-21 5-32a128 128 0 10-218 90l129 130c95-16 169-92 182-188zm0 0"/><path fill="#b3b3b3" d="M704 416H384a32 32 0 110-64h320a32 32 0 110 64zm0 0"/><path fill="#fff" fill-opacity=".2" d="M382 360h324c13 0 24 8 30 19-3-15-16-27-32-27H384c-16 0-29 11-31 26 5-11 16-18 29-18zm0 0"/><path fill="#666" fill-opacity=".5" d="M736 384c0 18-14 32-32 32h-99c-13 96-87 172-182 188l126 127a384 384 0 00219-347zm0 0"/><path fill-opacity=".1" d="M384 160a224 224 0 00-224 224v4c2-122 102-220 224-220 90 0 155 54 155 54-40-38-95-62-155-62zm0 0"/><path fill="url(#a)" fill-rule="evenodd" d="M768 384a384 384 0 11-768 0 384 384 0 01768 0zm0 0"/>',
  token: '<path d="M112 709c0 35 29 64 64 64h401c36 0 64-29 64-64V44a40 40 0 0 0-80 0v40H176c-35 0-64 28-64 64v561zm116-545h298c19 0 35 16 35 35v170c0 20-16 35-35 35H228c-20 0-36-15-36-35V199c0-19 16-35 36-35zm-36 345a40 40 0 1 1 81 0 40 40 0 0 1-81 0zm145 0a40 40 0 1 1 80 0 40 40 0 0 1-80 0zm144 0a40 40 0 1 1 80 0 40 40 0 0 1-80 0zM192 653a40 40 0 1 1 81 0 40 40 0 0 1-81 0zm145 0a40 40 0 1 1 80 0 40 40 0 0 1-80 0zm144 0a40 40 0 1 1 80 0 40 40 0 0 1-80 0z"/>',
  user: '<path d="M468 548c-17-3-17-49-17-49s49-48 59-113c29 0 47-69 18-93 1-26 37-201-143-201S240 267 241 293c-28 24-11 93 18 93 11 65 59 113 59 113s0 46-17 49c-53 8-253 96-253 193h673c0-97-199-185-253-193z"/>',
  key: '<path d="M529 20a240 240 0 0 0-236 284L0 597v144c0 27 22 48 48 48h48v-48h96v-96h97v-96h96l62-63a240 240 0 0 0 323-226c0-133-108-240-241-240zm72 240a72 72 0 1 1 0-144 72 72 0 0 1 0 144zm0 0"/>',
};

const changeImgInterval = 8000;

// Extract prefix from metadata
const prefix = document.querySelector('meta[name="prefix"]').getAttribute('content');

// Extract prefix from metadata
const gallery = document.querySelector('meta[name="gallery"]').getAttribute('content').split(';');

// Extract token Required from metadata
const isTokenRequired = document.querySelector('meta[name="token"]')?.getAttribute('content') === '1';

// Define language to use
const supportedLanguages = [ 'en', 'nl' ];
const browserLanguages = [ ...navigator.languages ].reverse();
let language = localStorage['webdesq/gui/language'];
if (!supportedLanguages.includes(language)) {
  browserLanguages.forEach(l => {
    if (supportedLanguages.includes(l)) {
      language = l;
    }
  });
}
if (!supportedLanguages.includes(language)) {
  language = 'en';
}

const resetPwPasswords = {};
let loaded = false,
  busy = false,
  paused = true,
  index,
  tokenUrl = '',
  resetPw = 0,
  resetPwToken = '',
  resetPwUser = undefined,
  setupToken = false,
  error,
  bg,
  logo,
  username,
  usernameValue = '',
  password,
  passwordValue = '',
  token,
  tokenValue = '',
  loginbox,
  x, y;

$: paused = setupToken || usernameValue != '' || passwordValue != '' || tokenValue != '';

const labels = {
  login: {
    en: 'Log in',
    nl: 'Log in',
  },
  username: {
    en: 'Username',
    nl: 'Gebruikersnaam',
  },
  password: {
    en: 'Password',
    nl: 'Wachtwoord',
  },
  passwordTwo: {
    en: 'Another time',
    nl: 'Nog een keer',
  },
  token: {
    en: 'Token',
    nl: 'Token',
  },
  continue: {
    en: 'continue',
    nl: 'verder',
  },
  tokenrequired: {
    en: 'Two Factor Authentication required',
    nl: 'Meervoudige authenticatie verplicht',
  },
  forgotpw: {
    en: 'Oops, I forgot my password',
    nl: 'Oei, ik ben mijn wachtwoord vergeten',
  },
  requestPw: {
    en: 'To request a new password, enter your username and your token below. If valid, you\'ll receive an e-mail with futher instructions.',
    nl: 'Vul hieronder je gebruikersnaam en je token in om een nieuw wachtwoord aan te vragen. Als deze correct zijn ontvang je een e-mail met verdere instructies.',
  },
  requestPwSuccess: {
    en: 'An e-mail has been sent to your inbox. Follow the instructions in it to reset your password.',
    nl: 'Er is een e-mail gestuurd naar je inbox. Volg de instructies die erin staan om je wachtwoord te herstellen.',
  },
  qrdone: {
    en: 'Yes, QR code has been registered',
    nl: 'Ja, QR code is ingescand',
  },
  qr1: {
    en: `<p>To protect your user account you have to log in by entering your password and a <b>6 digit</b> token.</p>
         <p>You need to use the <b>Authenticator</b> app on your smartphone to scan and register a QR code.</p>
         <p>If you don't have this app installed on your smartphone, click on the iOS AppStore or Google Play store to download.</p>`,
    nl: `<p>Om je gebruikersaccount beter te beveiligen moet je inloggen met je wachtwoord en een <b>6 cijferige</b> code (een token).</p>
         <p>Je moet de <b>Authenticator</b> app op je smartphone gebruiken om een QR code te scannen.</p>
         <p>Indien je deze app niet op je smartphone hebt staan, klik dan op iOS AppStore of Google Play store om deze nu te installeren.</p>`,
  },
  qr2: {
    en: '<p>If the <b>Authenticator</b> app is installed, click \'continue\'</p>',
    nl: '<p>Als de <b>Authenticator</b> app is geinstalleerd, klik dan op \'verder\'</p>',
  },
  qr3: {
    en: '<p>Scan the QR code below using the Authicator app. Click the button below if you have succesfully registered the QR code.</p>',
    nl: '<p>Scan de QR code met de Authicator app. Klik op de knop eronder als de QR code succesvol is geregistreerd.</p>',
  },
  requestNewPw: {
    en: 'Request new password',
    nl: 'Nieuw wachtwoord aanvragen',
  },
  saveNewPw: {
    en: 'Save password',
    nl: 'Wachtwoord opslaan',
  },
  pwResetWait: {
    en: 'Validating reset token, please wait...',
    nl: 'Token aan het valideren, even geduld...',
  },
  pwResetHelp: {
    en: 'Hi <m>, enter a new password two times in the fields below and click \'update\'.',
    nl: 'Hallo <m>, vul twee keer je nieuwe wachtwoord in en klik op \'opslaan\'.',
  },
  pwResetSuccess: {
    en: 'Your password has been reset successfully. You can now use it to log in to your account',
    nl: 'Gelukt! Je kan je nieuwe wachtwoord gebruiken op in te loggen in je account.',
  },
  SomethingWrong: {
    en: 'Something went wrong',
    nl: 'Er is iets mis gegaan',
  },
  INVALID_ENTRIES: {
    en: 'Invalid entries!',
    nl: 'Onjuiste gegevens!',
  },
  EXPIRED_USER: {
    en: 'Your account has expired',
    nl: 'Je account is verlopen',
  },
  DISABLED_USER: {
    en: 'Your account is disabled',
    nl: 'Je account is uitgeschakeld',
  },
  INVALID_FORMID: {
    en: 'Session expired. Login again please.',
    nl: 'De session is verlopen. Log opnieuw in.',
  },
  PASSWORDS_DIFFER: {
    en: 'The two passwords must be identical to each other.',
    nl: 'De twee wachtwoorden moeten identiek zijn.',
  },
  TOO_SHORT: {
    en: 'Password is too short',
    nl: 'Wachtwoord is te kort',
  },
};

function submit() {
  const data = {
    username: usernameValue,
    password: passwordValue,
    token: tokenValue,
    formid: document.querySelector('meta[name="formid"]').getAttribute('content'),
  };
  busy = true;
  error = false;
  fetch(prefix + '/login', {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'post',
    body: JSON.stringify(data),
  })
    .then(response => response.json())
    .then(async data => {
      busy = false;
      if (data.success) {
        // force reload
        window.location = prefix;
      }
      else if (data.error && data.error == 'INVALID_FORMID') {
        // page expired, reload
        usernameValue = '';
        passwordValue = '';
        tokenValue = '';
        error = data.error;
        window.location = prefix;
      }
      else if (data.error && data.error == 'TOKEN_REQUIRED') {
        // system requires token, but user has no token key defined
        tokenValue = '';
        tokenUrl = data.url;
        setupToken = 1;
        await tick();
      }
      else {
        await tick();
        error = data.error;
        passwordValue = '';
        tokenValue = '';
        username.focus();
      }
    });
}

function requestPwReset() {
  error = undefined;
  const data = {
    username: usernameValue,
    token: tokenValue,
    formid: document.querySelector('meta[name="formid"]').getAttribute('content'),
    lang: language,
  };

  fetch(prefix + '/login/reset', {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'post',
    body: JSON.stringify(data),
  })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        resetPw = 2;
      }
      else if (data.error) {
        error = data.error;
      }
    })
    .catch(() => {
      error = labels.SomethingWrong;
      console.error(error);
    });
}

function performPwReset() {
  error = undefined;

  // Ensure entered passwords are equal to each other
  if (resetPwPasswords.pw1 !== resetPwPasswords.pw2) {
    error = 'PASSWORDS_DIFFER';
    return;
  }

  const data = {
    token: resetPwToken,
    password: resetPwPasswords.pw1,
    formid: document.querySelector('meta[name="formid"]').getAttribute('content'),
  };

  fetch(prefix + '/login/reset/' + resetPwToken, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'post',
    body: JSON.stringify(data),
  })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        resetPw = 5;
      }
      else {
        error = data.error || 'SomethingWrong';
      }
    });
}

function changeImg() {
  if (!paused) {
    index++;
    if (index >= gallery.length) {
      index = 0;
    }
  }
}

if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function () {
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}

function onTokenInput() {
  if (tokenValue) {
    tokenValue = tokenValue.replace(/[^\d]/g, '');
    if (!resetPw && tokenValue.length === 6 && usernameValue && passwordValue) {
    // Is tokenValue 6 characters long? then submit form
      submit();
    }
  }
}

onMount(async () => {
  // Display first gallery image, and start interval to change pics every 8 seconds
  index = Math.floor(Math.random() * gallery.length);
  window.setInterval(changeImg, changeImgInterval);
  loaded = true;
  await tick();
  // Focus username field
  username.focus();

  // Handle password reset request
  if (window.location.search?.includes('resetpw')) {
    const search = Object.fromEntries(window.location.search.slice(1).split('&').map(p => p.split('=')));
    resetPwToken = search.resetpw;
    resetPw = 3;

    fetch(prefix + '/login/reset/' + resetPwToken)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          resetPw = 4;
          resetPwUser = data.user;
        }
        else {
          resetPw = 0;
        }
      })
      .catch(() => error = labels.SomethingWrong);
  }
});

</script>

<style>
:global(html), :global(body) {
  position: relative;
  width: 100%;
  height: 100%;
}

:global(body) {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  border: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
  background-color: #465a84;
  color: #444;
  background-position: 50%;
  background-size: cover;
}

input {
  font-family: inherit;
  font-size: inherit;
  padding: 0.4em;
  margin: 0 0 0.5em 0;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 2px;
}

input:disabled {
  color: #ccc;
  background: #fff;
}

svg.input {
  width: 22px;
  height: 20px;
  stroke: #000;
  fill: #777;
  position: absolute;
  top: 7px;
  left: 7px;
}

svg.authapp {
  width: 58px;
  height: 58px;
  padding: 10px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 4px -2px #444;
  position: static;
  float: right;
  margin: 8px 4px 5px 14px;
}

.logo {
  background-size: contain;
  height: 48px;
  background-repeat: no-repeat;
  margin: 0 0 12px 0;
}

.loginbox {
  width: 260px;
  box-sizing: border-box;
  max-width: calc(100% - 20px);
  background: rgba(241, 241, 241, 0.985);
  position: absolute;
  top: 50%;
  left: 50%;
  padding: 12px 15px;
  border-radius: 3px;
  bottom: auto;
  box-shadow: 0 2px 5px -1px #000;
  overflow: hidden;
  text-align: left;
  transform: translate3d(-50%,-50%,0);
  transition: transform 1s ease-in-out, width 200ms;
}

.loginbox.paused {
  transition: transform 150ms ease-in-out, width 200ms;
}


.loginbox.wide {
  max-width: calc(100% - 20px);
  width: 350px;
}

.loginbox div {
  position: relative;
  /* text-align: center; */
}

.loginbox input {
  box-sizing: border-box;
  display: block;
  font-size: 120%;
  font-weight: 700;
  border: none;
  background: #fafafa;
  padding: 8px 8px 8px 40px;
  width: 100%;
}

.loginbox input:focus {
  outline: none;
  background-color: rgba(0, 0, 0, 0.08);
}

.loginbox input:focus + svg {
  fill: #000;
  transform: scale(1.1);
}

.loginbox input.submit {
  width: 100%;
  height: auto;
  padding: 8px;
  border: 1px solid rgba(70, 90, 132, 0.15);
  display: block;
  margin: 8px 0 4px 0;
  border-radius: 2px;
  color: #444;
  background-color: #f5f5f5;
  background-image: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.05) 100%);
  background-image: -o-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.05) 100%);
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.05) 100%);
  transition: background-color 0.2s, border 0.2s;
  box-shadow: inset 0 1px 0 #ffffff1a, 0 1px 2px #0000001a;
  cursor: pointer;
}

.loginbox input.submit:hover, .loginbox input.submit:focus {
  border: 1px solid #465a84;
}

.loginbox h3 {
  margin: 0 0 10px 0;
}

.loginbox .forgotpw {
  opacity: .6;
  font-size: 90%;
  margin-top: 17px;
  display: block;
  cursor: pointer;
  display: block;
  text-align: center;
}
.loginbox .forgotpw:hover {
  opacity: 1;
}

.loginbox .scancode {
  margin-top: 14px;
  border: 18px solid transparent;
}

div.errormsg {
  border-radius: 3px;
  background-color: #ff4646;
  padding: 3px 10px;
  color: #fff;
  margin-bottom: 9px;
  font-weight: 700;
}

.storelink > svg {
  width: 49%;
}

.bg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-size: cover;
  background-position: 50%;
}

</style>

{#if loaded}
  <div bind:this={bg} class="bg" style="background-image: url({prefix}{gallery[index]})" />
  <form bind:this={loginbox} class="loginbox" class:paused style="{paused ? '' : `transform: translate3D(${x}px, ${y}px, 0);`}" class:wide={setupToken || resetPw} on:submit|preventDefault={submit}>
    {#if setupToken == 1}
      <div>
        <h3>{labels.tokenrequired[language]}</h3>
        <svg class="authapp" viewbox="0 0 768 768">{@html icons.authenticator}</svg>
        {@html labels.qr1[language]}
        <a class="storelink" rel="nofollow noopener noreferrer" target="_blank" href="https://apps.apple.com/us/app/google-authenticator/id388497605">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 768 228"><defs/><path fill="#a6a6a6" d="M740.7 228H26.9A27 27 0 010 201V27A27 27 0 0127 0h713.7c15 0 27 12 27.3 27v174c-.2 15-12.4 27-27.3 27zm0 0"/><path d="M762.5 201c0 12.1-9.8 21.9-21.8 21.9H26.9A21.8 21.8 0 015.1 201V27c0-12 9.8-21.8 21.8-21.8h713.8a21.8 21.8 0 0121.8 22v174zm0 0"/><path fill="#fff" d="M171.4 112.7A33 33 0 01187.1 85c-6.1-8.7-16-14-26.6-14.4-11.2-1.1-22 6.7-27.7 6.7-5.9 0-14.6-6.6-24-6.3a35.4 35.4 0 00-29.9 18.2c-13 22.3-3.3 55.2 9.1 73.2 6.2 8.9 13.4 18.8 22.8 18.5 9.2-.4 12.7-6 23.9-6 11 0 14.3 6 23.9 5.7 9.9-.1 16.2-8.9 22.1-17.8a73.2 73.2 0 0010.2-20.6 32 32 0 01-19.5-29.5zm-18.2-54c5.4-6.5 8-14.8 7.4-23.2a33 33 0 00-21.3 11 31 31 0 00-7.7 22.5c8.4 0 16.4-3.7 21.6-10.3zm0 0M305.2 179.6h-13l-7-22.3h-24.6l-6.8 22.3h-12.5l24.3-75.9h15l24.6 75.9zM283 147.9l-6.3-19.8c-.7-2-2-6.8-3.9-14.2h-.2c-.7 3.2-2 8-3.6 14.2l-6.2 19.9H283zm84.8 3.7c0 9.3-2.5 16.6-7.5 22a22 22 0 01-16.7 7.2c-7.2 0-12.3-2.6-15.5-7.7h-.2v28.7h-12.2V143c0-5.9-.1-11.9-.4-18H326l.7 8.7h.2c3.8-6.5 10.9-10.2 18.4-9.9 6.4 0 11.8 2.6 16.1 7.7a30.5 30.5 0 016.4 20.2zm-12.3.4c0-5.3-1.2-9.7-3.6-13.1a12.4 12.4 0 00-10.6-5.5c-3 0-5.7 1-8.1 3a14 14 0 00-4.8 7.8c-.3 1.5-.5 2.7-.5 3.7v9c0 4 1.2 7.5 3.6 10.2 2.5 2.6 5.6 4 9.5 4 4.5 0 8.1-1.6 10.7-5.2 2.5-3.5 3.8-8.2 3.8-14zm75.1-.4a31 31 0 01-7.5 22 22 22 0 01-16.7 7.2c-7.2 0-12.4-2.6-15.5-7.7h-.2v28.7h-12.2V143c0-5.9-.1-11.9-.4-18h10.6l.7 8.7h.2c3.9-6.5 11-10.3 18.5-9.9 6.4 0 11.8 2.6 16.1 7.7a30.2 30.2 0 016.4 20.2zm-12.3.4c0-5.3-1.2-9.7-3.6-13.1a12.4 12.4 0 00-10.6-5.5c-3 0-5.7 1-8.1 3-2.4 2-4 4.6-4.8 7.8a15 15 0 00-.5 3.7v9.1c0 4 1.2 7.4 3.6 10.1 2.4 2.8 5.6 4.1 9.5 4.1 4.5 0 8.1-1.7 10.7-5.2 2.5-3.6 3.8-8.2 3.8-14zm82.6 6.3c0 6.4-2.3 11.7-6.8 15.8-5.8 4.7-13.1 7-20.6 6.6a36 36 0 01-19.6-4.7l2.8-10.2a32.9 32.9 0 0017.5 4.9c4.6 0 8.2-1 10.7-3.1 2.5-2 3.8-4.9 3.8-8.3 0-3-1-5.7-3.2-7.8-3-2.6-6.5-4.6-10.4-5.9-13.2-5-19.9-12.2-19.9-21.7 0-6.3 2.4-11.4 7-15.4s10.8-5.9 18.6-5.9a37 37 0 0117.1 3.6l-3 10a30.2 30.2 0 00-14.5-3.6c-4.2 0-7.6 1-10 3.2-2 1.8-3 4.1-3 6.8 0 3 1.1 5.5 3.4 7.5a39 39 0 0011 5.8 37 37 0 0114.4 9.3 19 19 0 014.6 13zm40-24.4h-13.3v26.7c0 6.7 2.3 10 7 10 2.2 0 4-.1 5.4-.5l.4 9.2c-2.4 1-5.5 1.4-9.5 1.4-4.7 0-8.5-1.5-11.2-4.4-2.7-3-4-7.9-4-14.8V134h-8V125h8v-10l11.9-3.6v13.6H541v9.1zm60.4 17.9c0 8.4-2.4 15.3-7.2 20.7a25.6 25.6 0 01-20 8.3c-8 0-14.4-2.7-19.2-8-4.7-5.3-7.1-12-7.1-20.1 0-8.5 2.4-15.4 7.4-20.9 5-5.4 12.3-8.4 19.8-8 8 0 14.4 2.6 19.3 8a29 29 0 017 20zm-12.6.4c0-5-1-9.4-3.3-13a12 12 0 00-10.9-6.6c-4.8 0-8.5 2.2-11 6.6-2.4 4-3.5 8.6-3.3 13.2 0 5 1 9.4 3.2 13 2.6 4.3 6.3 6.5 11 6.5s8.3-2.2 11-6.7c2.2-3.6 3.3-8 3.3-13zm52-16.7l-3.8-.3c-4.3 0-7.6 1.7-10 4.9-2 3.2-3.1 7-3 10.8v28.7h-12V142c0-6.3-.1-12-.4-17.2H622l.5 10.4h.3c1.3-3.6 3.3-6.4 6.1-8.6 2.7-2 5.6-2.9 8.8-2.9 1.1 0 2 0 3 .2zm54.3 14.1c0 1.9-.2 3.7-.5 5.6h-36.4a16 16 0 005.3 12.3c3 2.6 7 3.8 12 3.8 5.3 0 10.2-.8 14.6-2.5l1.9 8.4c-5.8 2.4-12 3.6-18.3 3.4-7.4.4-14.6-2.3-19.9-7.5-5-5.4-7.6-12.7-7.3-20.1 0-8.2 2.3-15.1 6.7-20.5a23.2 23.2 0 0119.2-8.9c7.8 0 13.8 3 17.8 8.8a29.8 29.8 0 014.9 17.2zm-11.7-3.1c.2-3.3-.6-6.5-2.3-9.4-2-3.4-5.3-5-9.7-5-4 0-7.1 1.6-9.6 5-2 2.7-3.3 6-3.6 9.4zm0 0M279 57c0 6.8-2 11.8-6 15.2-4.5 3.4-10.1 5-15.8 4.7a75 75 0 01-8.7-.5V39.8c3.1-.5 6.5-.8 10.2-.8 6.6 0 11.4 1.5 14.8 4.3 3.7 3.2 5.5 7.8 5.5 13.8zm-6.2.2c0-4.3-1.2-7.7-3.5-10s-5.7-3.4-10-3.4c-2 0-3.5 0-4.9.3V72l4 .2c4.6 0 8.1-1.3 10.6-3.9 2.5-2.5 3.8-6.2 3.8-11zm39.5 5.7c0 4.1-1.1 7.6-3.4 10.2a12.7 12.7 0 01-9.9 4 12 12 0 01-9.4-3.9 14.3 14.3 0 01-3.5-9.8c0-4.2 1.2-7.6 3.6-10.3 2.5-2.7 5.7-4 9.7-4 4 0 7.2 1.3 9.6 4a14 14 0 013.4 9.8zm-6.1.2c0-2.5-.6-4.6-1.6-6.4-1-2-3.1-3.2-5.4-3.2a6 6 0 00-5.4 3.2c-1.1 1.8-1.6 4-1.6 6.5s.6 4.6 1.6 6.4c1.3 2.1 3 3.2 5.4 3.2 2.3 0 4-1 5.3-3.3a12 12 0 001.7-6.4zM357 49.7l-8.4 26.9h-5.5l-3.5-11.7a85 85 0 01-2.1-8.7h-.1a65 65 0 01-2.2 8.7l-3.7 11.7h-5.5l-7.9-26.9h6l3.1 12.8 1.9 8.6c.5-2.3 1.2-5.2 2.3-8.6l3.7-12.8h5l3.6 12.5c.8 3.1 1.6 6 2.1 8.9h.2c.4-2.8 1-5.7 1.8-8.9l3.3-12.5zM388 76.6h-6V61.2c0-4.8-1.8-7.1-5.4-7.1-1.7 0-3.3.7-4.3 2a7 7 0 00-1.7 4.5v16h-6V57.4l-.1-7.7h5.2l.3 4.2h.2a9.8 9.8 0 018.5-4.7c2.5 0 4.5.7 6.2 2.4 2 2 3 5 3 8.9zm16.4 0h-6V37.4h6zm35.1-13.7c0 4.1-1.1 7.6-3.5 10.2a12.7 12.7 0 01-9.8 4 12 12 0 01-9.4-3.9 14.3 14.3 0 01-3.6-9.8c0-4.2 1.2-7.6 3.7-10.3 2.4-2.7 5.6-4 9.7-4 4 0 7.1 1.3 9.5 4a14 14 0 013.4 9.8zm-6.2.2c0-2.5-.5-4.6-1.6-6.4-1-2-3-3.2-5.3-3.2a6 6 0 00-5.5 3.2c-1 1.8-1.6 4-1.6 6.5s.6 4.6 1.6 6.4c1.3 2.1 3 3.2 5.4 3.2 2.3 0 4-1 5.4-3.3a12 12 0 001.6-6.4zm35 13.5H463l-.4-3.1h-.2a9.2 9.2 0 01-7.9 3.7 8 8 0 01-6-2.5 7.6 7.6 0 01-2.1-5.4c0-3.3 1.3-5.8 4-7.6 2.8-1.7 6.6-2.5 11.7-2.5v-.5c0-3.5-2-5.3-5.6-5.3-2.7 0-5 .7-7 2l-1.2-4a17 17 0 019.1-2.2c7 0 10.6 3.6 10.6 11v10c0 2.6 0 4.8.4 6.4zm-6.1-9.3v-4c-6.6-.2-9.9 1.6-9.9 5.3 0 1.4.4 2.5 1.2 3.2.7.6 1.7 1 2.9 1a6 6 0 003.6-1.2c1.4-1 2.2-2.6 2.2-4.3zm40 9.3H497l-.2-4.3h-.2c-1.7 3.2-4.5 4.9-8.6 4.9-3.3 0-6-1.3-8-3.8a15 15 0 01-3.3-9.9c0-4.4 1.2-8 3.5-10.6 2.3-2.5 5-3.8 8.3-3.8 3.6 0 6.1 1.3 7.6 3.7V37.4h6v32l.2 7.2zm-6.1-11.3v-4.6c0-2-.8-4-2.3-5.5a6 6 0 00-4-1.4 6 6 0 00-5.3 2.6c-1.3 2-2 4.4-2 6.9 0 2.6.7 4.8 2 6.4 1.2 1.8 3 2.7 5.1 2.7 2 0 3.6-.8 4.8-2.3 1.1-1.3 1.7-3 1.7-4.9zm57.1-2.4c0 4.1-1 7.6-3.5 10.2a12.7 12.7 0 01-9.8 4c-4 0-7-1.2-9.4-3.9a14.3 14.3 0 01-3.5-9.8c0-4.2 1.2-7.6 3.6-10.3 2.5-2.7 5.6-4 9.7-4 4 0 7.1 1.3 9.5 4a14 14 0 013.4 9.8zm-6.2.2c0-2.5-.5-4.6-1.6-6.4a6 6 0 00-5.3-3.2 6 6 0 00-5.5 3.2c-1 1.8-1.5 4-1.5 6.5s.5 4.6 1.5 6.4c1.3 2.1 3.1 3.2 5.4 3.2 2.3 0 4-1 5.4-3.3a12 12 0 001.7-6.4zm38.3 13.5h-6V61.2c0-4.8-1.8-7.1-5.4-7.1-1.7 0-3.2.6-4.3 2a7.2 7.2 0 00-1.7 4.5v16h-5.8V57.4l-.3-7.7h5.3l.3 4.2h.1a8.7 8.7 0 013-3.2A10 10 0 01576 49c2.5 0 4.6.8 6.3 2.5 2 2 3 5 3 8.9v16zM625.4 54h-6.6v13.2c0 3.3 1.2 5 3.5 5 1.1 0 2-.2 2.7-.4l.2 4.6c-1.2.4-2.8.6-4.7.6-2.3 0-4.2-.7-5.5-2.1-1.3-1.5-2-3.9-2-7.3V54.1H609v-4.4h3.9v-5l5.8-1.7v6.7h6.6zM657 76.6h-6V61.3c0-4.8-1.8-7.2-5.4-7.2-2.8 0-4.6 1.4-5.7 4.2-.2.5-.2 1.3-.2 2.1v16.2h-6V37.4h6v16.2a9 9 0 018-4.5c2.6 0 4.6.8 6.2 2.5 2 2 3 5 3 9zm32.5-14.8c0 1.2 0 2-.2 2.8h-17.9c.1 2.6 1 4.7 2.6 6a8.8 8.8 0 005.9 1.9c2.6 0 5-.4 7.2-1.3l1 4.2a21.6 21.6 0 01-9 1.7 13 13 0 01-9.9-3.7 13.6 13.6 0 01-3.5-9.9c0-4 1-7.4 3.3-10 2.3-3 5.8-4.6 9.4-4.4a10 10 0 018.8 4.3c1.6 2.3 2.4 5.1 2.4 8.4zm-5.7-1.5c0-1.7-.3-3.3-1.1-4.6a5.2 5.2 0 00-4.8-2.5c-1.8 0-3.6 1-4.7 2.5a9 9 0 00-1.8 4.6h12.5zm0 0"/></svg>
        </a>
        <a class="storelink" rel="nofollow noopener noreferrer" target="_blank" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 768 227"><defs><path id="reuse-1" d="M0 0h768v228H0z"/><path id="reuse-0" fill-opacity=".2" d="M0 0h768v227H0z"/></defs><defs><linearGradient id="e" x1="1682.1" x2="1624.3" y1="1339.5" y2="1309.6" gradientTransform="matrix(1.6445 0 0 -3.1913 -2642.8 4324)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#00a0ff"/><stop offset="0" stop-color="#00a1ff"/><stop offset=".3" stop-color="#00beff"/><stop offset=".5" stop-color="#00d2ff"/><stop offset=".8" stop-color="#00dfff"/><stop offset="1" stop-color="#00e3ff"/></linearGradient><linearGradient id="f" x1="1712.7" x2="1606.6" y1="1274.8" y2="1274.8" gradientTransform="matrix(1.292 0 0 -1.08971 -2021.2 1502.7)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#ffe000"/><stop offset=".4" stop-color="#ffbd00"/><stop offset=".8" stop-color="orange"/><stop offset="1" stop-color="#ff9c00"/></linearGradient><linearGradient id="g" x1="1707.4" x2="1646.7" y1="1290" y2="1211.2" gradientTransform="matrix(2.12203 0 0 -1.63846 -3482.6 2240.3)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#ff3a44"/><stop offset="1" stop-color="#c31162"/></linearGradient><linearGradient id="h" x1="1660.6" x2="1687.8" y1="1365.7" y2="1330.5" gradientTransform="matrix(2.12203 0 0 -1.63761 -3482.6 2237.5)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#32a071"/><stop offset=".1" stop-color="#2da771"/><stop offset=".5" stop-color="#15cf74"/><stop offset=".8" stop-color="#06e775"/><stop offset="1" stop-color="#00f076"/></linearGradient><clipPath id="b"><use xlink:href="#reuse-1"/></clipPath><clipPath id="c"><use xlink:href="#reuse-1"/></clipPath><clipPath id="d"><use xlink:href="#reuse-1"/></clipPath><mask id="j"><g filter="url(#a)"><use fill-opacity=".2" xlink:href="#reuse-0"/></g></mask><mask id="l"><g filter="url(#a)"><use fill-opacity=".1" xlink:href="#reuse-0"/></g></mask><mask id="n"><g filter="url(#a)"><use fill-opacity=".3" xlink:href="#reuse-0"/></g></mask><g id="i" clip-path="url(#b)"><path fill-rule="evenodd" d="M153.1 137L71 183.7c-4.5 2.7-8.6 2.5-11.3.1l-.4.5.4.4c2.7 2.2 6.8 2.5 11.3-.2l82.8-47zm0 0"/></g><g id="k" clip-path="url(#c)"><path fill-rule="evenodd" d="M181.4 120.9l-28.4 16 .6.5 27.7-15.7c4-2.3 5.9-5.2 5.9-8.2-.3 2.7-2.3 5.2-5.8 7.4zm0 0"/></g><g id="m" clip-path="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M71 43.3l110.4 62.8c3.5 2 5.5 4.7 5.8 7.4.1-3-1.8-6-5.8-8.2L70.9 42.5c-7.9-4.6-14.4-.8-14.4 8.3v.7c0-9 6.5-12.7 14.4-8.2zm0 0"/></g><filter id="a" width="100%" height="100%" x="0%" y="0%" filterUnits="objectBoundingBox"><feColorMatrix in="SourceGraphic" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"/></filter></defs><path fill-rule="evenodd" d="M739.5 227H28.4A28.4 28.4 0 010 198.7V28.4A28.4 28.4 0 0128.4 0h711A28.5 28.5 0 01768 28.4v170.3a28.5 28.5 0 01-28.5 28.3zm0 0"/><path fill="#a6a6a6" fill-rule="evenodd" d="M739.5 4.5a24 24 0 0124 24v170.2a24 24 0 01-24 23.8H28.4a24 24 0 01-23.9-23.8V28.4A24 24 0 0128.4 4.5zm0-4.5H28.4A28.4 28.4 0 000 28.4v170.3A28.4 28.4 0 0028.4 227h711a28.5 28.5 0 0028.6-28.3V28.4A28.5 28.5 0 00739.5 0zm0 0"/><path fill="#fff" d="M404.6 75.1a18 18 0 01-18-18.3 18 18 0 0118-18.4 18 18 0 0118.1 18.4 18.1 18.1 0 01-18 18.3zm-152.6 0c-5 0-9.4-1.8-13-5.3a17.4 17.4 0 01-5.3-13c0-5.3 1.8-9.7 5.3-13a17.8 17.8 0 0120.3-3.9 13 13 0 015.3 4l.4.4-3.8 3.7-.4-.4c-2.2-2.6-5.5-4-8.9-3.9a12.6 12.6 0 00-12.6 13 12.6 12.6 0 0012.6 13c3.7 0 6.8-1 9.2-3.5a9.6 9.6 0 002.5-6h-12.3v-5.1H269l.1.4.3 2.7c0 4.8-1.6 8.7-4.4 11.7a17.4 17.4 0 01-12.9 5.2zm203-.8h-5.6L433 47.8l.1 4.7v21.8h-5.3V39.2h6l.3.3 15.6 24.9-.2-4.7V39.2h5.5zm-91 0h-5.6V44.4H349v-5.2h24.4v5.2h-9.5zm-19.6 0H339V39.2h5.5zm-30.6 0h-5.5V44.4h-9.5v-5.2h24.4v5.2h-9.4zm-18.5 0h-21V39.2h21v5.2h-15.6v9.7h14v5.2H280v9.6h15.4zm100.4-8.2c2.4 2.4 5.4 3.7 9 3.7 3.5 0 6.3-1.2 8.7-3.7 2.4-2.4 3.7-5.5 3.7-9.3 0-3.9-1.3-7-3.7-9.4a12.1 12.1 0 00-8.8-3.7 12.7 12.7 0 00-12.6 13c0 3.9 1.3 7 3.7 9.4zm0 0"/><path fill="#fff" fill-rule="evenodd" d="M386 123.4a23.8 23.8 0 00-24.2 24.2 23.9 23.9 0 0024.2 24.2 23.8 23.8 0 0024.1-24.2c0-14-10.7-24.2-24.1-24.2zm0 38.8c-7.4 0-13.6-6.1-13.6-14.6 0-8.8 6.4-14.7 13.6-14.7 7.3 0 13.5 6 13.5 14.7 0 8.6-6.2 14.6-13.5 14.6zm-52.7-38.8a23.7 23.7 0 00-24.2 24.2 23.9 23.9 0 0024.2 24.2 23.9 23.9 0 0024.1-24.2c0-14-10.8-24.2-24.1-24.2zm0 38.8c-7.4 0-13.6-6.1-13.6-14.6 0-8.8 6.2-14.7 13.6-14.7 7.3 0 13.5 6 13.5 14.7 0 8.6-6.2 14.6-13.5 14.6zm-62.7-31.3v10.2H295c-.7 5.7-2.7 9.9-5.5 12.9a25.5 25.5 0 01-19 7.5 27 27 0 01-26.8-27.3 26.9 26.9 0 0145.4-20l7.2-7.2a38 38 0 00-63.6 27.2 37.8 37.8 0 0037.9 37.3c11.1 0 19.6-3.5 26-10.4a33.8 33.8 0 009-24c0-2.4-.2-4.5-.6-6.3h-34.4zm256.7 8c-2.2-5.6-8.2-15.5-20.8-15.5-12.3 0-22.6 9.8-22.6 24.2 0 13.5 10.2 24 23.9 24a24 24 0 0020-10.7l-8.2-5.4c-2.5 4.2-7 6.7-11.8 6.7-5.4 0-9.2-2.6-11.8-7.4l32.2-13.3zm-33 8a13.3 13.3 0 0112.6-14.2c4.3 0 7.8 2.2 9 5.1zm-26.1 23.3h10.5V99.3h-10.5zm-17.4-41.4h-.4c-2.4-2.8-7-5.4-12.7-5.4a24 24 0 00-23.2 24.2c0 13.6 11 24 23.2 24 5.6 0 10.3-2.5 12.7-5.5h.4v3.6c0 9.2-5 14.1-12.8 14.1-6.5 0-10.6-4.6-12.2-8.6l-9.2 3.8a22.8 22.8 0 0021.4 14.3c12.3 0 22.9-7.3 22.9-25.2v-43.3h-10zm-12.1 33.4c-7.4 0-13.4-6.1-13.4-14.6s6-14.7 13.4-14.7c7.2 0 12.7 6.2 12.7 14.7.1 8.5-5.5 14.6-12.7 14.6zm138-62.9h-25.3v71H562v-27h14.7c11.7 0 23.3-8.4 23.3-21.9 0-13.4-11.4-22-23.3-22zm.3 34.2h-15V109h15c8 0 12.4 6.7 12.4 12.2 0 5.6-4.5 12.2-12.4 12.2zm65.4-10c-7.8 0-15.7 3.3-19 10.7l9.5 4c2-4 5.7-5.3 9.6-5.3 5.6 0 11 3.2 11.2 9v.9c-2-1.1-6-2.8-11-2.8-10.2 0-20.5 5.6-20.5 16 0 9.4 8.3 15.7 17.7 15.7 7 0 11-3.3 13.4-7h.4v5.4h10.2V143c0-12.6-9.5-19.5-21.5-19.5zm-1.3 38.7c-3.5 0-8.3-1.7-8.3-6.1 0-5.5 6-7.5 11.2-7.5 4.6 0 6.9 1 9.6 2.4-.7 6.4-6.1 11.2-12.5 11.2zm60-37.4l-12.2 30.9h-.4l-12.6-30.9h-11.3l18.8 43-10.8 24h11l29.2-67zm-95.3 45.5h10.6v-71h-10.6zm0 0"/><path fill="url(#e)" fill-rule="evenodd" d="M59 42.7a11.5 11.5 0 00-2.5 8.1v125.4c0 3.5 1 6.4 2.7 8l.4.3 70.2-70.3v-1.5L59.6 42.3zm0 0"/><path fill="url(#f)" fill-rule="evenodd" d="M153.1 137.8l-23.4-23.5v-1.6l23.4-23.4.6.3 27.7 15.7c8 4.5 8 11.9 0 16.4l-27.7 15.7zm0 0"/><path fill="url(#g)" fill-rule="evenodd" d="M153.7 137.4l-24-23.9-70.6 70.8c2.6 2.8 6.9 3 11.8.4l82.8-47.3"/><path fill="url(#h)" fill-rule="evenodd" d="M153.7 89.6L71 42.5c-5-2.9-9.2-2.4-11.8.4l70.6 70.6zm0 0"/><use mask="url(#j)" xlink:href="#i"/><use mask="url(#l)" xlink:href="#k"/><use mask="url(#n)" xlink:href="#m"/></svg>
        </a>
        {@html labels.qr2[language]}
      </div>
      <div>
        <input type="submit" twoway="false" on:click={() => (setupToken = 2)} class="submit" value="{labels.continue[language]}" />
      </div>
    {:else if setupToken == 2}
      <div>
        <h3>{labels.tokenrequired[language]}</h3>
        {@html labels.qr3[language]}
      </div>
      <div class="scancode">
        <QrCode text={tokenUrl} />
      </div>
      <div>
        <input type="submit" twoway="false" on:click={() => (setupToken = false)} class="submit" value="{labels.qrdone[language]}" />
      </div>
    {:else if resetPw === 1}
      <div>
        <p>{labels.requestPw[language]}</p>
      </div>
      <div>
        <input disabled={busy} tabindex="0" type="text" placeholder={labels.username[language]} name="user" autocomplete="off" bind:value={usernameValue} bind:this={username} />
        <svg class="input" viewbox="0 0 768 768">{@html icons.user}</svg>
      </div>
      <div>
        <input maxlength="6" disabled={busy} tabindex="0" type="text" placeholder={labels.token[language]} name="token" autocomplete="off" bind:value={tokenValue} bind:this={token} />
        <svg class="input" viewbox="0 0 768 768">{@html icons.token}</svg>
      </div>
      {#if error}
        <div class="errormsg">
          {#if labels[error]}
            {labels[error][language]}
          {:else}
            {labels['SomethingWrong'][language]}: {error}
          {/if}
        </div>
      {/if}
      <div>
        <input type="button" twoway="false" on:click={requestPwReset} class="submit" value="{labels.requestNewPw[language]}" />
      </div>
    {:else if resetPw === 2}
      <div>
        <p>{labels.requestPwSuccess[language]}</p>
      </div>
    {:else if resetPw === 3}
      <div>
        <p>{labels.pwResetWait[language]}</p>
      </div>
    {:else if resetPw === 4}
      <div>
        <p>{labels.pwResetHelp[language]?.replace('<m>', resetPwUser?.name?.first || resetPwUser?.id || '')}</p>
      </div>
      <div>
        <input readonly tabindex="0" type="text" placeholder={labels.username[language]} name="user" autocomplete="off" value={resetPwUser?.id} />
        <svg class="input" viewbox="0 0 768 768">{@html icons.user}</svg>
      </div>
      <div>
        <input disabled={busy} tabindex="0" type="password" placeholder={labels.password[language]} name="pw" autocomplete="off" bind:value={resetPwPasswords.pw1} bind:this={password} />
        <svg class="input" viewbox="0 0 768 768">{@html icons.key}</svg>
      </div>
      <div>
        <input disabled={busy} tabindex="0" type="password" placeholder={labels.passwordTwo[language]} name="pw" autocomplete="off" bind:value={resetPwPasswords.pw2} bind:this={password} />
        <svg class="input" viewbox="0 0 768 768">{@html icons.key}</svg>
      </div>
      {#if error}
        <div class="errormsg">
          {#if labels[error]}
            {labels[error][language]}
          {:else}
            {labels['SomethingWrong'][language]}: {error}
          {/if}
        </div>
      {/if}
      <div>
        <input type="button" twoway="false" on:click={performPwReset} class="submit" value="{labels.saveNewPw[language]}" />
      </div>
    {:else if resetPw === 5}
      <div>
        <p>{labels.pwResetSuccess[language]}</p>
      </div>
      <div>
        <input type="button" twoway="false" class="submit" value="{labels.login[language]}" on:click={() => resetPw = 0} />
      </div>
    {:else}
      <div bind:this={logo} class="logo" style="background-image: url({prefix}/assets/logo.svg)"/>
      {#if error}
        <div class="errormsg">
          {#if labels[error]}
            {labels[error][language]}
          {:else}
            {labels['SomethingWrong'][language]}: {error}
          {/if}
        </div>
      {/if}
      <div>
        <input disabled={busy} tabindex="0" type="text" placeholder={labels.username[language]} name="user" autocomplete="off" bind:value={usernameValue} bind:this={username} />
        <svg class="input" viewbox="0 0 768 768">{@html icons.user}</svg>
      </div>
      <div>
        <input disabled={busy} tabindex="0" type="password" placeholder={labels.password[language]} name="pw" autocomplete="off" bind:value={passwordValue} bind:this={password} />
        <svg class="input" viewbox="0 0 768 768">{@html icons.key}</svg>
      </div>
      {#if isTokenRequired}
        <div>
          <input maxlength="6" disabled={busy} tabindex="0" type="text" placeholder={labels.token[language]} name="token" autocomplete="off" bind:value={tokenValue} bind:this={token} on:input={onTokenInput} />
          <svg class="input" viewbox="0 0 768 768">{@html icons.token}</svg>
        </div>
      {/if}
      {#if busy}
        <div><Loader /></div>
      {:else}
        <div>
          <input type="submit" twoway="false" class="submit" value="{labels.login[language]}" />
          {#if isTokenRequired}
            <span on:pointerdown={() => resetPw = 1} class="forgotpw" role="button">{labels.forgotpw[language]}</span>
          {/if}
        </div>
      {/if}
    {/if}
  </form>
{/if}
